import { ReactNode } from "react";
import {
    UseFormReturn,
    DefaultValues,
    SubmitHandler,
} from "react-hook-form";
import { ZodType } from "zod";

export enum FormStatusEnum { Edit, List, Add };

export interface FormWrapperProps<TFormValues extends Record<string, any>> {
    children: ReactNode | ((methods: UseFormReturn<TFormValues>) => ReactNode);
    onSubmit: SubmitHandler<TFormValues>;
    canSave?: boolean;
    canDelete?: boolean;
    defaultValues?: DefaultValues<TFormValues>;
    schema?: ZodType<TFormValues>;
    className?: string;
    formStatus?: FormStatusEnum;
    onDelete: (id: string) => void;
}
